const AboutPage = () => {
  return <h1>About 페이지입니다</h1>;
};

export default AboutPage;
